import {defineStore} from 'pinia'
import api from '../api'

export const useProductStore = defineStore("ProductStore", {
    state: () => {
        return {
            products: [],
            path: 'data'
        }
    },

    actions: {
        async fill(path) {
            console.log(path);
            this.products = (await api.get('/api' + path)).data;
        }
    }
})
